import React, { memo } from "react";
import { InboxSlashIcon, InboxIcon } from "modules/icons";
import colors from "app/colors";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import { DistributionGroupFragment } from "gql/graphql";

interface IProps {
  userId: string;
  distributionGroup: DistributionGroupFragment;
}

const DistributionGroupInboxIndicator = ({
  userId,
  distributionGroup,
}: IProps) => {
  const isNotifications =
    distributionGroup.notificationUserIdList.includes(userId);

  if (isNotifications) {
    return (
      <SyncoTooltip label="Group messages sent to Threads Inbox">
        <InboxIcon fill={colors.blue} boxSize={5} />
      </SyncoTooltip>
    );
  }

  return (
    <SyncoTooltip label="Group messages not sent to Threads Inbox">
      <InboxSlashIcon fill={colors.grayMain} boxSize={5} />
    </SyncoTooltip>
  );
};

export default memo(DistributionGroupInboxIndicator);
